module.exports = __webpack_public_path__ + "img/bus-area-04.0bb89905.png";